/**
 * Runtime error hierarchy.
 *
 * All runtime errors extend `RuntimeError` so callers can rely on a
 * stable `code` for diagnostics and centralized handlers.
 */

export class RuntimeError extends Error {
  readonly code: string;
  override readonly cause?: unknown;

  constructor(code: string, message: string, cause?: unknown) {
    super(message);
    this.name = "RuntimeError";
    this.code = code;
    if (cause !== undefined) this.cause = cause;
  }
}

export class RuntimeAbortError extends RuntimeError {
  constructor(message = "Flow execution aborted") {
    super("ABORT", message);
    this.name = "RuntimeAbortError";
  }
}

export class TransportError extends RuntimeError {
  readonly status?: number;
  readonly responseBody?: unknown;

  constructor(
    message: string,
    options?: { status?: number; responseBody?: unknown; cause?: unknown },
  ) {
    super("TRANSPORT", message, options?.cause);
    this.name = "TransportError";
    if (options?.status !== undefined) this.status = options.status;
    if (options?.responseBody !== undefined) {
      this.responseBody = options.responseBody;
    }
  }
}

export class StreamError extends RuntimeError {
  constructor(message: string, cause?: unknown) {
    super("STREAM", message, cause);
    this.name = "StreamError";
  }
}

export class ExpressionError extends RuntimeError {
  constructor(message: string, cause?: unknown) {
    super("EXPRESSION", message, cause);
    this.name = "ExpressionError";
  }
}

export class StepError extends RuntimeError {
  readonly stepType: string;

  constructor(stepType: string, message: string, cause?: unknown) {
    super("STEP", `[${stepType}] ${message}`, cause);
    this.name = "StepError";
    this.stepType = stepType;
  }
}
